<template>
  <cargo-company-select
    :multiple="multiple"
    :default-value="multiple ? '' : value"
    :default-multiple-value="multiple ? value : []"
    v-bind="$attrs"
    v-on="new$listeners"
    @change="onChange"
  />
</template>

<script>
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'CargoCompanySelectStandard',
  components: {
    cargoCompanySelect
  },
  props: {
    multiple: { type: Boolean, default: false }, // （是否多选）
    value: { type: [String, Number, Boolean, Array], required: true }
  },
  computed: {
    new$listeners() {
      const result = { ...this.$listeners }
      delete result.change
      return result
    }
  },
  methods: {
    onChange(data) {
      let newValue = data instanceof Object ? data.value : data
      if (newValue === '') {
        if (typeof this.value === 'number') {
          newValue = 0
        }
      }
      if (newValue !== this.value) {
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  }
}
</script>
